import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import MainToggle from '@wix/da-ds/pkg/formControls/dsPresets/MainToggle';
import ButtonFieldLayout from '../../../../layouts/common/ButtonFieldLayout';
import { OriginalDeviationFieldName } from '../../types';

import s from './ProgressIsVisibleField.scss';

const ProgressIsVisibleField: React.FC<{}> = () => {
  const { t } = useTranslation();
  const id = useId();
  const { control } = useFormContext();
  const { field } = useController({
    name: OriginalDeviationFieldName.PROGRESS_IS_VISIBLE,
    control,
  });

  return (
    <ButtonFieldLayout
      label={t('originalDeviationPopup.form.progressIsVisible.label')}
      labelClassName={s['label']}
      labelProps={{ id: `${id}-label`, htmlFor: id }}
      subLabel={t('originalDeviationPopup.form.progressIsVisible.subLabel')}
      subLabelClassName={s['sub-label']}
    >
      <MainToggle
        id={id}
        variant="main"
        size="large"
        aria-labelledby={`${id}-label`}
        value={field.value}
        onChange={field.onChange}
      />
    </ButtonFieldLayout>
  );
};
ProgressIsVisibleField.displayName = 'ProgressIsVisibleField';

export default ProgressIsVisibleField;
